module.exports = __webpack_public_path__ + "static/img/7.b16385a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/eng/7.png
// module id = bgFG
// module chunks = 0